let env = null;
if (process.env.REACT_APP_ENV === 'LOCALHOST') {
  env = 'local';
}
if (process.env.REACT_APP_ENV === 'DEVELOPMENT') {
  env = 'dev';
}
if (process.env.REACT_APP_ENV === 'STAGING') {
  env = 'stage';
}
if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  env = 'prod';
}
const constants = {
  env,
  apiHost: process.env.REACT_APP_API_HOST,
  environment: process.env.REACT_APP_ENV,
  workspaceId: process.env.REACT_APP_WORKSPACE_ID,
  utilityHost: process.env.REACT_APP_API_UTILITY_HOST,
  masterApi: process.env.REACT_APP_API_MASTER_API,
  emaiLDomain: process.env.REACT_APP_EMAIL_DOMAIN,
  obligationsUrl: process.env.REACT_APP_OBLIGATIONS_URL,
  recoveryUrl: process.env.REACT_APP_RECOVERY_URL,
  hostingerApiKey: process.env.REACT_APP_HOSTINGER_API_KEY,
  userId: process.env.REACT_APP_USER_ID,
  sharePointName: process.env.REACT_APP_SHAREPOINT_NAME,
  sharePointUser: process.env.REACT_APP_SHAREPOINT_USER,
  onedriveUserId: process.env.REACT_APP_ONEDRIVE_USER_ID,
  wordeditorApi: process.env.REACT_APP_DOCXEDITOR_API_HOST,
  licenseKey: process.env.REACT_APP_DOCXEDITOR_LICENSE_KEY,
};

export default constants;
